import PokerstarsMobileLogoLink from 'images/loghi/logo-pokerstars-mobile.svg?react';
import PokerstarsLogoLink from 'images/loghi/logo-pokerstars.svg?react';
import { useIsAtLeastDesktopBreakpoint } from 'utils/hooks/media-queries';
import { BaseHomepageLink, BaseHomePageLinkProps } from './base-homepage-link';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type PokerstarsHomepageLinkProps = BaseHomePageLinkProps & {
  iconSize: string;
  iconHeight: string;
};

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const PokerstarsHomepageLink = ({
  iconSize,
  ...props
}: PokerstarsHomepageLinkProps) => {
  const isAtLeastDesktop = useIsAtLeastDesktopBreakpoint();

  const logoComponent = isAtLeastDesktop
    ? PokerstarsLogoLink
    : PokerstarsMobileLogoLink;

  return (
    <BaseHomepageLink
      iconSize={iconSize}
      svgIconComponent={logoComponent}
      {...props}
    />
  );
};

export { PokerstarsHomepageLink };
